import s from './info.module.css';
import React from "react";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";


const Delivery = () => {

    useDocumentTitle('Доставка');

    return (
        <div className={s.info}>
            <div className={`${s.infoContent} content`}>
                <Breadcrumbs/>
                <div className={s.delivery}>
                    <h3>Доставка</h3>
                    <h5>Доставка по Украине</h5>
                    <p>Интернет-магазин "Статус-Текстиль" предоставляет бесплатную доставку в любой город Украины при
                        заказе на сумму от 1000 гривен и полной предоплате . Доставка осуществляется транспортными
                        компаниями "Новая Почта", "Деливери", "ИнТайм", экспресс-доставкой "Мист Экспресс" а так же
                        УкрПочта. Работаем как по предоплате на банковскую карту, так и услугой наложенный платеж. Срок
                        доставки товара составляет в среднем от 1 до 3 рабочих днем (в зависимости от региона доставки).
                        Ваш заказ будет принят и обработан, наш менеджер свяжется с Вами перед отправкой товара для
                        уточнения всех нюансов и деталей.
                    </p>
                    <h5>Доставка по Полтаве</h5>
                    <p>Интернет-магазин "Статус-Текстиль" предоставляет бесплатную доставку по городу Полтава при заказе
                        на сумму от 500 гривен. Передача товара из рук в руки, оплата по факту получения.
                    </p>
                    <h5>Обратите внимание:</h5>
                    <p>При обнаружении заводского брака, несоответствии расцветок либо же каких либо других погрешностей
                        - в течении 14 рабочих дней обмениваем продукцию на соответствующую, либо же возвращаем 100%
                        суммы, оплаченной Вами.</p>
                </div>
            </div>
        </div>
    )
}

export default Delivery;